import React from 'react';
import {I18n} from './i18n/I18n';

export const EmptyResults = ({className}) => <I18n class={className || ''} t='Empty results' />;
